import React from 'react';
import { Paper, Grid, Box} from '@material-ui/core';
import { withStyles} from '@material-ui/core/styles';
import './styles.scss'

import IconHead from './../../components/IconHead';
import ContainedButton from './../../components/ContainedButton';

import SelectCounty from './components/SelectCounty';
import CountiesMap from './components/CountiesMap';
import FWH from './components/FusariumWiltHistory';
import FWO from './components/FusariumWiltObserved';
import Bioassay from './components/Bioassay';
import PlantingDate from './components/PlantingDate';
import Graft from './components/Graft';
import Fumigation from './components/Fumigation';
import FumigationProduct from './components/FumigationProduct';
import Risk from './components/Risk';

const useStyles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }
});

class HomeComponent extends React.Component  {

  constructor(props) {
    super(props);

    this.state = {
      countyFp: '',
      fwh: '',
      fwo: '',
      plantingDate:[],
      bioassay:'',
      graft: '',
      fumigation: '',
      fumigationProduct: '',
      displayFwh: 'none',
      displayFumigationProduct: 'none',
      displayRisk: 'none',
      risks: []
    };

    this.setCounty = this.setCounty.bind(this);
    this.setPlantingDate = this.setPlantingDate.bind(this);
    this.setFwh = this.setFwh.bind(this);
    this.setFwo = this.setFwo.bind(this);
    this.setBioassay = this.setBioassay.bind(this);
    this.setGraft = this.setGraft.bind(this);
    this.setFumigation = this.setFumigation.bind(this);
    this.setFumigationProduct = this.setFumigationProduct.bind(this);
    this.calculateRisk = this.calculateRisk.bind(this);

    this.CountiesMap = React.createRef();
    this.SelectCounty = React.createRef();
    this.FWH = React.createRef();
    this.FWO = React.createRef();
    this.Bioassay = React.createRef();
    this.Graft = React.createRef();
    this.Fumigation = React.createRef();
    this.FumigationProduct = React.createRef();
  };

  setCounty(countyFp, origin) {
    this.setState({displayRisk: "none"});
    this.setState({
      countyFp: countyFp
    }, () => {
      if(origin === 'list'){
        this.CountiesMap.current.updateCountyOnMap(this.state.countyFp);
      }else if(origin === 'map'){
        this.SelectCounty.current.updateCountyOnList(this.state.countyFp);
      }
    })
  }

  setFwh(fwh) {
    this.setState({displayRisk: "none"});
    if(fwh === "true"){
      this.setState({displayFwh: 'block'});
    }else{
      this.setState({displayFwh: 'none'});
    }
    this.setState({fwh: fwh});
  }

  setFwo(fwo) {
    this.setState({displayRisk: "none"});
    this.setState({fwo: fwo});
  }

  setPlantingDate(pd) {
    this.setState({displayRisk: "none"});
    this.setState({plantingDate: pd});
  }

  setBioassay(bioassay) {
    this.setState({displayRisk: "none"});
    this.setState({bioassay: bioassay});
  }

  setGraft(graft) {
    this.setState({displayRisk: "none"});
    this.setState({graft: graft});
  }

  setFumigation(fumigation) {
    this.setState({displayRisk: "none"});
    if(fumigation === "true"){
      this.setState({displayFumigationProduct: 'block'});
    }else{
      this.setState({displayFumigationProduct: 'none'});
    }
    this.setState({fumigation: fumigation});
  }

  setFumigationProduct(product) {
    this.setState({displayRisk: "none"});
    this.setState({fumigationProduct: product});
  }

  calculateRisk(){
    
    let pdKey;
    let risks = [];
    let regions = {
      north :['127','083','075','035','107', '109', '029', '007', '019', '031', '089','001', '041', '003', '125', '023', '121', '067', '047', '123', '079', '065', '073', '129', '037', '077', '039', '045', '013', '063', '005', '133', '059', '131', '091', '113', '033'],
      central: ['115', '027', '055', '093', '085', '111', '061', '081', '049', '097', '009', '095', '105', '057', '103', '101', '053', '119', '069', '017', '117'],
      south: ['087','086','011','099', '021', '071', '051', '043','015']
    };

    for (let [key, value] of this.state.plantingDate) {
      let risk = 2;
      let title = '';

      // Planting Date
      if(key === "early" & value === true){
        title = "Planting Date: Early";
        pdKey = 1;
        risk = risk + 20;
      }else if(key === "middle" & value === true){
        title = "Planting Date: Middle";
        pdKey = 2;
        risk = risk + 0;
      }else if(key === "late" & value === true){
        title = "Planting Date: Late";
        pdKey = 3;
        risk = risk - 20;
      }else{
        continue;
      }

      // Region
      if(regions.north.includes(this.state.countyFp)){
        risk = risk + 20;
      }else if(regions.central.includes(this.state.countyFp)){
        risk = risk + 10;
      }else if(regions.south.includes(this.state.countyFp)){
        risk = risk + 5;
      }else {
        break;
      }

      // Fusarium Wilt History
      if(this.state.fwh === 'true'){
        if(this.state.fwo === '0-2'){
          risk = risk + 50;
        }else if(this.state.fwo === '3-7'){
          risk = risk + 20;
        }else if(this.state.fwo === '8-more'){
          risk = risk + 10;
        }
      }else if(this.state.fwh === 'false'){
        risk = risk + 0;
      }

      // Bioassay
      if(this.state.bioassay === 'true'){
        risk = risk + 50;
      }else if(this.state.bioassay === 'false'){
        risk = risk + 0;
      }

      // Graft
      if(this.state.graft === 'true'){
        risk = 2;
      }else if(this.state.graft === 'false'){
        risk = risk + 0;
      }

      // Fumigation
      if(this.state.fumigation === 'true'){
        if(this.state.fumigationProduct === 'telone'){
          risk = risk + 0;
        }else if(this.state.fumigationProduct === 'chloropicrin'){
          risk = risk - 40;
        }
      }else if(this.state.graft === 'false'){
        risk = risk + 0;
      }

      if(risk < 2){
        risk = 2;
      }
      if(risk > 100){
        risk = 100;
      }

      risks.push({
        key: pdKey,  
        title: title,
        risk: risk
      });

    }

    if(risks.length > 0){
      this.setState({displayRisk: "block"});
      this.setState({risks: risks.sort((a,b) => a.key - b.key)});
    }
  }

  render(){
    const { classes } = this.props;
    return(
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Paper>
              <div className="head-paper">
                <IconHead title="Choose a county" body="Select the county in which the field you plan to grow is located.  The counties are listed in alphabetical order."/>
                <h4>Choose a county</h4>
              </div>
              <SelectCounty selectValue={this.setCounty} ref={this.SelectCounty}/>
            </Paper>
            <br></br>
            <Paper>
              <div className="head-paper">
                <IconHead title="Planting dates" body="What dates are you planning to plant this season?  The dates to choose from will change based on which county you have selected."/>
                <h4>Planting dates</h4>
              </div>
              <PlantingDate selectValue={this.setPlantingDate} countySelected={this.state.countyFp} ref={this.PlantingDate}/>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Paper>
              <div className="head-paper">
                <IconHead title="Choose one of the Florida's counties" body="The counties are divided into north (orange), central (green) and south (blue) regions."/>
                <h4>Map of counties</h4>
              </div>
              <CountiesMap selectValue={this.setCounty} ref={this.CountiesMap}/>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              <Grid container>
                <Grid item xs={6}>
                  <div className="head-paper">
                    <IconHead title="Fusarium wilt history" body="Has there ever been a case of Fusarium wilt within the field in which you plan to grow?"/>
                    <h4>Fusarium wilt history</h4>
                  </div>
                  <FWH selectValue={this.setFwh} ref={this.FWH}/>
                </Grid>
                <Grid item xs={6}>
                  <Box display={this.state.displayFwh}>
                    <div className="head-paper">
                      <IconHead title="How many years has it been since you last planted watermelons or had Fusarium wilt in this field?" body="If there has been a case of Fusarium wilt in this field, how many years has it been since you last planted watermelons or had Fusarium wilt in this field?"/>
                      <h4>How many years has it been since you last planted watermelons or had Fusarium wilt in this field?</h4>
                    </div>
                    <FWO selectValue={this.setFwo} ref={this.FWO}/>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              <div className="head-paper">
                <IconHead title="Detected by Bioassay" body="Was Fusarium wilt detected in a bioassay of the soil from this field?"/>
                <h4>Detected by Bioassay</h4>
              </div>
              <Bioassay selectValue={this.setBioassay} ref={this.Bioassay}/>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              <div className="head-paper">
                <IconHead title="Grafted roots" body="Are you using plants that have been grafted with rootstocks resistant to Fusarium wilt?"/>
                <h4>Grafted roots</h4>
              </div>
              <Graft selectValue={this.setGraft} ref={this.Graft}/>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              <Grid container>
                <Grid item xs={6}>
                  <div className="head-paper">
                    <IconHead title="Fumigation" body="Have you or will you fumigate this field for this season?"/>
                    <h4>Fumigation</h4>
                  </div>
                  <Fumigation selectValue={this.setFumigation} ref={this.Fumigation}/>
                </Grid>
                <Grid item xs={6}>
                  <Box display={this.state.displayFumigationProduct}>
                    <div className="head-paper">
                      <IconHead title="What fumigation products did you use?" body="If you have fumigated or plan to for this season, which product did you or will you use?"/>
                      <h4>What fumigation products did you use?</h4>
                    </div>
                    <FumigationProduct selectValue={this.setFumigationProduct} ref={this.FumigationProduct}/>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper>
              <Box display="flex" justifyContent="center">
                <ContainedButton action={this.calculateRisk} name={"Calculate risk"}/>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Box display={this.state.displayRisk}>
              <Paper>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <div className="head-paper">
                      <IconHead title="Risk calculated" body="The estimated probability that Fusarium wilt will occur in this field based on your answers.  To see how different answers change this calculation, change one or more answers and click “Calculate Risk” again."/>
                      <h4>Risk calculated</h4>
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Risk risks={this.state.risks}/>
                </Grid>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default {
    routeProps: {
        path: '/home',
        component: withStyles(useStyles)(HomeComponent)
    },
    name: 'Home',
}
